import { render, staticRenderFns } from "./GCP.vue?vue&type=template&id=7a06d74f&"
import script from "./GCP.vue?vue&type=script&lang=js&"
export * from "./GCP.vue?vue&type=script&lang=js&"
import style0 from "./GCP.vue?vue&type=style&index=0&id=7a06d74f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports